<template>
  <el-card class="voucher-card"
           shadow="nerver">
    <!-- 页头 -->
    <div style="font-size: 20px">
      <span class="el-icon-info">个人中心</span>
    </div>
    <!-- 账号类型 -->
    <div style="margin-top: 50px; font-size: 15px">
      <span style="padding-right: 30px">账号类型:</span>年会员/达人号
    </div>
    <!-- 公司名称 -->
    <el-divider content-position="right">
      <el-link>
        <!-- action="" 上传到的地址-->
        <el-upload action="http://121.196.53.21:8081/user/avatar"
                   :name="file_name"
                   :show-file-list="false"
                   :with-credentials="true"
                   :on-success="handleAvatarSuccess"
                   :before-upload="beforeAvatarUpload"
                   accept=".jpg, .jpeg, .png, .gif">
          <i class="el-icon-edit">修改</i>
        </el-upload>
      </el-link>
    </el-divider>
    <div style="font-size: 15px">
      <!-- 图片栏 -->
      <div class="avatar-area">
        <div style="display: inline-block">
          <span style="padding-right: 30px">账号头像:</span>
        </div>

        <div>
          <img class="img-user"
               v-if="imageUrl"
               :src="imageUrl" />
          <img class="img-user"
               v-else
               :src="imageDef" />
        </div>
      </div>
    </div>

    <!-- 联系电话 -->
    <el-divider content-position="right">
      <el-link icon="el-icon-edit">编辑</el-link>
    </el-divider>
    <div style="font-size: 15px">
      <span style="padding-right: 30px">公司电话:</span>13701584465
    </div>
    <!-- 负责人 -->
    <el-divider content-position="right">
      <el-link icon="el-icon-edit">编辑</el-link>
    </el-divider>
    <div style="font-size: 15px">
      <span style="padding-right: 47px">联系人:</span>Allen
    </div>
    <el-button @click="getTest">测试</el-button>
  </el-card>
</template>

<script>
export default {
  name: 'Profile',
  data() {
    return {
      file_name: 'avatar',
      imageUrl: '',
      imageDef:
        'http://img4.imgtn.bdimg.com/it/u=3701847413,2165986719&fm=11&gp=0.jpg',
    }
  },
  methods: {
    async getcookie() {
      // let cookie = this.getCookie("csrf_token");

      let functionCallable = this.$agconnect.function().wrap('test-$latest')
      functionCallable.timeout = 30000
      let functionResult = await functionCallable.call()
      let returnValue = functionResult.getValue()
      console.log('szsxT' + JSON.stringify(returnValue))
    },
    // 上传文件前 的 钩子 函数
    beforeAvatarUpload(file) {
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isFORMAT) {
        this.$message.error('上传头像图片只能是 JPG/png/gif 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isFORMAT && isLt2M
    },
    // 上传成功使的钩子函数，将返回值添加到页面中
    handleAvatarSuccess(res, file) {
      // URL.createObjectURL(file.raw)web API
      this.imageUrl = URL.createObjectURL(file.raw)
    },

    // 测试
    // 获取产品列表信息
    getTest() {
      console.log('xxxxx')
      this.loading = true
      this.$http
        .get(`/product/get_product_list?p_no=1&p_size=92`)
        .then((res) => {
          console.log(res)
          const { data, errno, errmsg } = res.data
          this.pagecount = res.data.pages
          this.total = res.data.product_account
          this.prodinfo = []
          if (data.length !== 0) {
            for (let pro of data) {
              // 建立对象，并将对象 push到列表
              let item = {}
              item.spu_id = pro.spu_id
              item.title = pro.spu_name
              item.updataDate = pro.last_update_time
              item.prod_image = pro.spu_avatar
              item.dest = pro.dest
              item.operator = pro.operator
              this.prodinfo.push(item)
              // console.log(this.prodinfo);
              // 套餐名称，和id，添加到列表中
              item.sku_pkg = pro.sku
              this.loading = false
            }
          } else {
            this.loading = false
          }
          //console.log(this.prodinfo);
        })
    },
  },
}
</script>

<style>
.img-user {
  display: inline-block;
  overflow: hidden;
  width: 100px;
  height: 100px;
  border: 1px solid rgb(194, 194, 194);
}
.avatar-area {
  display: flex;
  position: relative;
  overflow: hidden;
}
</style>